import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../pnp-doc.constants';
import { getDocument } from '../pnp-doc.actions';
import { getDocumentCategories } from '../../pnp-docs.actions';
import watch from 'redux-watch';

class pnpDocumentGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpDocumentGrid;
        this.filterTemplate = './pnp-document-grid-filter.html';

        this.columns = [
            { title: '#', mapper: null },
            { title: 'Head Office', mapper: 'headOffice' },
            { title: 'Site Location', mapper: 'siteLocation' },
            { title: 'Department', mapper: 'department' },
            { title: 'Document Number', mapper: 'docNum' },
            { title: 'Version', mapper: 'version' },
            { title: 'Title', mapper: 'title' },
            { title: 'Document Category', mapper: 'documentCategory' },
            { title: 'Document Type', mapper: 'documentType' },
            { title: 'Author', mapper: 'author' },
            { title: 'Created Date', mapper: 'created_date' },
            { title: 'Approval Due Date', mapper: 'approvalDueDate' },
            { title: 'Document Due Date', mapper: 'documentDueDate' },
            { title: 'Status', mapper: 'docStatus' },
            { title: 'LinkedToAccreditation', mapper: 'linkWithAccreditation'}
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getDocument, getDocumentCategories }
        )(this);
        this.filter.identifier = this.identifier;
        this.dataAction = this.getDocument;
        this.exportService = this.getDocument;

        const watchLocation = watch(this.$ngRedux.getState, 'policies.pnpDocumentGrid.filter.location');
        this.unsubscribeLocation = this.$ngRedux.subscribe(watchLocation((location) => {
            this.getDocumentCategories(location);
        }));

        this.init();
        this.buttonsDefault[0].label = 'Archive'
        this.buttonsDefault = this.buttons.concat();
    }

    $onDestroy() {
        this.unsubscribeLocation();
        this.destroy();
    }
}

pnpDocumentGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const pnpDocumentGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: pnpDocumentGridController,
    ...gridTpl
}
